export default class DeleteVoiceAIRecording {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationItemId }) {
    this.context.gateways.voiceRecording.deleteVoiceAIRecording(customerId, conversationItemId);
  }
}
